import Vue from 'vue'

export default {
  methods: {

    // Display a model given a component & props
    // Returns a promise, which is resolved when the dialog is closed/finished
    displayModal(dialogComponent, props = {}, params = null, modalParams = {}) {
      var comClass = Vue.extend(dialogComponent)
      var dialogInstance = new comClass({
        propsData: props,
        parent: this.$parent
      })

      dialogInstance.$mount() // pass nothing
      if(modalParams.mountBody)
        document.body.appendChild(dialogInstance.$el)
      else
        this.$el.appendChild(dialogInstance.$el)

      if(props.onBeforeOpen != null && typeof props.onBeforeOpen === "function") {
        props.onBeforeOpen(dialogInstance)
      }

      // Force it so the dialog cannot be closed by clicking elsewhere
      modalParams.backdrop = 'static'
      modalParams.keyboard = false

      return dialogInstance.show(params, modalParams)
    },

    // Checks if any modal dialog class is current visible in the document
    isDocumentModalVisible() {
      let elements = document.getElementsByClassName("modal show")
      return !!elements[0]
    }
  }
}
